export default __webpack_public_path__ + "static/media/phone1.5df05f37.png";